import React from 'react'
import OpcionesImagen from './OpcionesImagen';

const OpcionesFooter = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;

    return (
        <>
            <div className='mb-2'>
                <h6>Ubicación</h6>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    defaultValue={styles?.direccionFooter}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'direccionFooter' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Teléfono</h6>
                <input
                    defaultValue={styles?.telefonoFooter}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'telefonoFooter' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Instagram</h6>
                <input
                    defaultValue={styles?.instagramFooter}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'instagramFooter' })}
                />
            </div>
            <OpcionesImagen {...props} />
        </>

    )
}

export default OpcionesFooter